import type { UserProfile } from '~/prix'

export const bypassUserProfile: UserProfile = {
  email: 'bypass@prix.tech',
  emailVerified: true,
  id: 'bypass',
  displayName: 'Bypass',
  phoneNumber: null,
  photoURL: null,
  cpf: '00000000000',
  activeClient: {
    clientId: 'bypass',
    municipalityId: 4462,
    stateId: 22,
    roles: ['systemAdministrator'],
    settings: {
      general: {
        preferredCoordinates: [-51.4686, -27.1294],
        preferredSpaceDelimitationType: 'municipality',
        preferredSpaceDelimitationId: 4462,
        preferredSpaceDelimitationTitle: 'Luzerna',
        preferredSpaceChildrenType: 'neighborhood',
      },
    },
  },
}
